<template>
  <div class="buttons-switcher">
    <label v-if="title" class="label">{{ title }}</label>

    <Button
      :disabled='disabled'
      v-for="item in items"
      :key="item.value || item"
      @click="toggle(item.value || item)"
      :class="{ active: value.includes(item.value || item) }"
      class="button"
    >
      {{ item.title || item }}
    </Button>
  </div>
</template>

<script>
import { Button } from 'element-ui';

export default {
  name: 'ButtonsSwitcher',
  components: {
    Button,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      required: true,
    },
    title: String,
  },
  methods: {
    toggle(value) {
      const values = [...(this.value || [])];
      const index = values.indexOf(value);

      if (index >= 0) {
        values.splice(index, 1);
      } else {
        values.push(value);
      }

      this.$emit('input', values);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

label {
  display: block;
  color: var(--text-tertiary);
  font-family: $font-family-regular;
  font-size: $font-size-xs;
  letter-spacing: 0.8px;
  line-height: $font-size-xs;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.button {
  font-family: $font-family-regular;
  font-size: $font-size-base;
  padding: 0px;
  min-height: 28px;
  min-width: 28px;
  background: var(--bg-tertiary);
  color: var(--text-muted);
  font-weight: bold;
  border: none;
  border-radius: $radius-sm;

  &.active {
    background: var(--status-info);
    color: $white;
  }
}

.button+.button {
  margin-left: $space-2;
}
</style>
